import { useController } from 'react-hook-form';
import classNames from 'classnames';
var classes = {
    toggleWrapper: {
        base: 'w-10 h-6 rounded-full bg-gray-300 p-0.5 transition-colors relative overflow-hidden',
        active: 'bg-alert-success',
    },
    circle: {
        base: 'h-5 w-5 rounded-full bg-white transition-transform transform-gpu pointer-events-none shadow-md',
        active: 'translate-x-4',
    },
    input: 'absolute opacity-0 top-0 left-0 w-full h-full cursor-pointer',
};
var TrueFalseInput = function (_a) {
    var label = _a.label, name = _a.name, control = _a.control, defaultValue = _a.defaultValue;
    var _b = useController({ name: name, control: control, defaultValue: defaultValue }), field = _b.field, fieldState = _b.fieldState;
    return (<div className="mb-2 flex w-full items-center justify-end">
      {label && (<label htmlFor={name} className="mr-2 text-xs text-gray-700">
          {label}
        </label>)}
      <div className={classNames(classes.toggleWrapper.base, field.value && classes.toggleWrapper.active)}>
        <div className={classNames(classes.circle.base, field.value && classes.circle.active)}/>
        <input type="checkbox" className={classNames(classes.input)} aria-label={label} name={name} id={name} defaultChecked={!!defaultValue} onClick={function () { return field.onChange(!field.value); }}/>
      </div>
    </div>);
};
export default TrueFalseInput;
